var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-btn"},[_c('button',{class:'base-btn__btn base-btn__btn--' + _vm.styleModifier,attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.emitClickEvent}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }